(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-coupon/assets/javascripts/route-coupon-view.js') >= 0) return;  svs.modules.push('/components/tipsen/route-coupon/assets/javascripts/route-coupon-view.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$ui = svs.ui,
  Brand = _svs$ui.ReactBrand,
  ReactButton = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon,
  IconButton = _svs$ui.ReactIconButton;
const _svs$ui$reactForm = svs.ui.reactForm,
  RadioButton = _svs$ui$reactForm.RadioButton,
  RadioGroup = _svs$ui$reactForm.RadioGroup;
const clx = svs.components.lbUtils.clx;
const _svs$components$poolB = svs.components.poolBetting.hooks,
  useDrawQueryParams = _svs$components$poolB.useDrawQueryParams,
  usePrintTracking = _svs$components$poolB.usePrintTracking;
const useDraw = svs.components.sport.drawsRedux.hooks.useDraw;
const SessionStorageKeys = svs.components.sport.tipsenShared.constants.SessionStorageKeys;
const PrintableDrawCard = svs.components.poolBetting.printableDrawCard.PrintableDrawCard;
const _svs$components$poolB2 = svs.components.poolBetting.printableCoupon,
  PrintableCoupon = _svs$components$poolB2.PrintableCoupon,
  PrintableCoupon1x2 = _svs$components$poolB2.PrintableCoupon1x2;
const useCouponQueryParamsLite = svs.components.tipsen.couponId.useCouponQueryParamsLite;
const useGetParticipantsByDraw = svs.components.tipsen.hooks.useGetParticipantsByDraw;
const _svs$components$tipse = svs.components.tipsen.routeCoupon,
  RotatePhone = _svs$components$tipse.RotatePhone,
  useCountdown = _svs$components$tipse.useCountdown;
const _svs$components$tipse2 = svs.components.tipsen.shareCoupon,
  ShareButton = _svs$components$tipse2.ShareButton,
  ShareStatus = _svs$components$tipse2.ShareStatus;
const getProductClassName = svs.utils.products.getProductClassName;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectOutcomesEventTypeId = svs.components.tipsen.engine.selectors.engineSelectors.selectOutcomesEventTypeId;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const PrintableBetInformation = svs.components.poolBetting.printableBetInformation.PrintableBetInformation;
const productIds = svs.utils.products.productIds;
const shareConfig = {
  title: 'Spela hos Svenska Spel S&C',
  text: "Spela hos Svenska Spel S&C"
};
const shareMessages = {
  [ShareStatus.CopiedToClipboard]: 'Länken är kopierad, dela den med dina vänner',
  [ShareStatus.CopiedToClipboardFallback]: 'Länken är kopierad, dela den med dina vänner',
  [ShareStatus.Text]: 'Kopiera länken och dela den med dina vänner',
  [ShareStatus.Shared]: ''
};
const CloseButton = _ref => {
  let onCloseClick = _ref.onCloseClick;
  return React.createElement(IconButton, {
    className: "route_coupon_view__close no_print",
    onClick: onCloseClick
  }, React.createElement(Icon, {
    color: "icon",
    icon: "close",
    size: "500"
  }));
};
const RouteCouponView = () => {
  usePrintTracking();
  const history = useHistory();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showSigns = _useState2[0],
    setShowSigns = _useState2[1];
  const _useDrawQueryParams = useDrawQueryParams(),
    productId = _useDrawQueryParams.productId,
    drawNumber = _useDrawQueryParams.drawNumber;
  const draw = useDraw({
    productId,
    drawNumber
  }, {
    skip: !productId || !drawNumber
  });
  const countdown = useCountdown(draw === null || draw === void 0 ? void 0 : draw.regCloseTime, 10);
  const participants = useGetParticipantsByDraw(productId, drawNumber);
  const _useCouponQueryParams = useCouponQueryParamsLite({
      draw
    }),
    signs = _useCouponQueryParams.signs,
    reductions = _useCouponQueryParams.reductions,
    outcomePairs = _useCouponQueryParams.outcomePairs,
    mSigns = _useCouponQueryParams.mSigns,
    uSigns = _useCouponQueryParams.uSigns,
    price = _useCouponQueryParams.price,
    system = _useCouponQueryParams.system;
  const eventTypeId = useSelector(selectOutcomesEventTypeId);
  const isPix = outcomePairs.length > 0;
  const isSystem = system && system.length > 0;
  const drawClosesInTenSeconds = countdown.timeLeftInSeconds <= 10;
  const isNotPlayableBet = drawClosesInTenSeconds || isPix;
  const isMatchen = parseInt(productId, 10) === productIds.MATCHEN;
  const handleTransferToGame = () => {
    const urlObj = new URL(window.location.href);
    const relativeUrl = "".concat(isSystem ? '/systemspel' : '/').concat(urlObj.search);
    history.push(relativeUrl);
  };

  const handleExit = () => {
    if (sessionStorage.getItem(SessionStorageKeys.ROUTE_CLIENT_PUSH)) {
      sessionStorage.removeItem(SessionStorageKeys.ROUTE_CLIENT_PUSH);
      history.goBack();
    } else {
      history.push('/');
    }
  };
  if (!draw) {
    return React.createElement("div", {
      className: "pg_route_coupon_view"
    }, React.createElement("h2", {
      className: "route_coupon__no_draw"
    }, "Det finns ingen kupong att visa"), React.createElement(CloseButton, {
      onCloseClick: handleExit
    }));
  }
  return React.createElement("div", {
    className: "pg_route_coupon_view"
  }, React.createElement(RotatePhone, {
    className: "no_print"
  }), React.createElement("div", {
    className: "route_coupon__print_content"
  }, React.createElement(Brand, {
    brand: getProductClassName(parseInt(productId, 10)),
    className: "route_coupon__brand",
    emblem: true
  }), React.createElement(PrintableDrawCard, {
    draw: draw
  }), (system || price) && React.createElement(PrintableBetInformation, {
    price: price,
    system: system
  }), eventTypeId === EventTypeId.RESULT && React.createElement(PrintableCoupon, {
    draw: draw,
    outcomePairs: showSigns ? outcomePairs : [],
    participants: participants,
    reductions: showSigns ? reductions : [],
    signs: showSigns ? signs : []
  }), eventTypeId === EventTypeId.EVENT_1X2 && React.createElement(PrintableCoupon1x2, {
    draw: draw,
    mSigns: showSigns ? mSigns : [],
    participants: participants,
    signs: showSigns ? signs : [],
    uSigns: showSigns ? uSigns : []
  })), React.createElement("div", {
    className: clx('route_coupon__buttons', 'no_print', {
      'route_coupon__buttons--print-only': isNotPlayableBet
    })
  }, !isMatchen && React.createElement(RadioGroup, {
    className: "route_coupon__buttons__show_signs",
    size: 100
  }, React.createElement(RadioButton, {
    checked: showSigns,
    onChange: () => setShowSigns(true),
    type: "radio",
    value: 0
  }, "Visa tecken"), React.createElement(RadioButton, {
    checked: !showSigns,
    onChange: () => setShowSigns(false),
    type: "radio",
    value: 1
  }, "D\xF6lj tecken")), React.createElement(ReactButton, {
    "aria-label": "Skriv ut",
    className: "route_coupon__buttons__print elevation-100",
    "data-testid": "route_coupon__buttons__print",
    onClick: e => {
      e.preventDefault();
      window.print();
    },
    size: 100
  }, "Skriv ut"), !isPix && React.createElement(ShareButton, {
    className: "route_my_bets__wager__buttons__share_bet elevation-100",
    shareConfig: shareConfig,
    shareMessages: shareMessages,
    shareText: window.location.href,
    size: 100
  }, "Dela"), !isMatchen && React.createElement(ReactButton, {
    "aria-label": "Spela kupong",
    className: clx('route_coupon__buttons__play_coupon', 'elevation-100', {
      'route_coupon__buttons__play_coupon--disabled': isNotPlayableBet
    }),
    "data-testid": "route_coupon__buttons__play_coupon",
    disabled: isNotPlayableBet,
    onClick: handleTransferToGame,
    size: 100
  }, "Spela kupong")), React.createElement(CloseButton, {
    onCloseClick: handleExit
  }));
};
setGlobal('svs.components.tipsen.routeCoupon.RouteCouponView', RouteCouponView);

 })(window);